<template>
  <base-form  class="noprogress">
    <template v-slot:header>
      {{ $t('qic_user_qid_header') }}
    </template>
    <UserIdForm @onSubmit="onSubmit" v-model="qid"/>
  </base-form>
</template>

<script>
import { BaseForm } from 'qic-components'
import UserIdForm from '@/components/UserIdForm'
export default {
  name: 'QidNumber',
  components: {
    BaseForm,
    UserIdForm
  },
  data () {
    return {
      qid: this.$store.state.renew.userData.qid
    }
  },
  methods: {
    onSubmit () {
      this.$router.push({ name: 'SelectPolicy', params: { qid: this.qid } })
    }
  }
}
</script>
